import {Component, Input, OnInit} from '@angular/core';
import {TranslationContainerComponent} from '../../../../components/abstract/translation-container.component';
import {CalculationService} from '../../../../../core/services/impl/calculation.service';

@Component({
  selector: 'app-insurance-data-summary',
  templateUrl: './insurance-data-summary.component.html',
  styleUrls: []
})
export class InsuranceDataSummaryComponent extends TranslationContainerComponent implements OnInit {

  @Input() headerVisible: boolean = true;
  @Input() context: InsuranceDataSummaryContext = InsuranceDataSummaryContext.OFFERS_LIST;
  entries: InsuranceDataSummaryEntry[];

  get isOffersPresentationContext(): boolean {
    return this.context === InsuranceDataSummaryContext.OFFERS_PRESENTATION;
  }

  constructor(private calculationService: CalculationService) {
    super('INSURANCE_DATA_SUMMARY');
  }

  ngOnInit() {
    this.createEntries();
  }

  private createEntries(): void {
    this.entries = [
      {
        label: this.getTranslationKey('firstName'),
        value: this.calculationService.ownerData.firstName
      },
      {
        label: this.getTranslationKey('lastName'),
        value: this.calculationService.ownerData.lastName
      },
      {
        label: this.getTranslationKey('registrationNumber'),
        value: this.calculationService.vehicleData.registrationNumber
      }
    ]
  }

}

export interface InsuranceDataSummaryEntry {
  label: string;
  value: string;
}

export enum InsuranceDataSummaryContext {
  OFFERS_LIST = 'OFFERS_LIST',
  OFFERS_PRESENTATION = 'OFFERS_PRESENTATION',
}
